import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { UiService } from 'src/app/services/ui.service'
import { AccountService } from '../../services/account.service'
import { ApplicationCreatorState } from '../../services/application-creator-state.service'
import { RegionsService } from 'src/app/services/regions.service'
import { ApplicationType } from 'src/app/services/dtos'

@Component({
  selector: 'application-creator-access-method-page',
  templateUrl: './application-creator-access-method-page.component.html',
  styleUrls: ['./application-creator-access-method-page.component.scss'],
  standalone: false,
})
export class ApplicationCreatorAccessMethodPageComponent implements OnInit {
  selectedMethod: 'cloudformation' | 'stacksets' = 'cloudformation'

  constructor(
    private applicationCreatorState: ApplicationCreatorState,
    private accountService: AccountService,
    public uiService: UiService,
    private router: Router,
    private regionsService: RegionsService
  ) {}

  ngOnInit() {
    // Guard: redirect if invalid state
    if (!this.applicationCreatorState.validAccountsAndRegions(this.regionsService)) {
      this.router.navigateByUrl(this.uiService.buildNewApplicationUrl(this.accountService.accountId))
      return
    }

    // Guard: redirect if choice already made or not AWS
    if (
      this.applicationCreatorState.applicationType !== ApplicationType.AWS ||
      this.accountService.hasStacksetsChoice
    ) {
      this.router.navigateByUrl(this.uiService.buildNewApplicationConnectionUrl(this.accountService.accountId))
      return
    }

    // Restore previously selected method from state (if any)
    if (this.applicationCreatorState.accessMethod) {
      this.selectedMethod = this.applicationCreatorState.accessMethod
    }
  }

  selectMethod(method: 'cloudformation' | 'stacksets') {
    this.selectedMethod = method
    // Save selection immediately so it persists if user clicks back
    this.applicationCreatorState.accessMethod = method
    this.applicationCreatorState.saveToLocalStorage()
  }

  get selectedMethodLabel(): string {
    return this.selectedMethod === 'stacksets' ? 'AWS StackSets' : 'CloudFormation Templates'
  }

  backButtonClick() {
    // Save current selection before going back
    this.applicationCreatorState.accessMethod = this.selectedMethod
    this.applicationCreatorState.saveToLocalStorage()
    this.router.navigateByUrl(this.uiService.buildNewApplicationUrl(this.accountService.accountId))
  }

  continueButtonClick() {
    // Save to application creator state and localStorage
    this.applicationCreatorState.accessMethod = this.selectedMethod
    this.applicationCreatorState.saveToLocalStorage()

    // Navigate to connect page
    this.router.navigateByUrl(this.uiService.buildNewApplicationConnectionUrl(this.accountService.accountId))
  }
}
